module.exports = __webpack_public_path__ + "img/eyyb-s2.997e82cd.jpg";